<template>
  <Popup
    header="Spaltennamen bearbeiten"
    @accept="acceptAndClose()"
    @abort="closePopup()"
  >
    <template v-slot:content>
      <div class="popupContent">
        <v-row>
          <v-col cols="6" v-for="spalte in spalten" :key="spalte.id">
            <b-text-field
              label="Spaltenname"
              type="text"
              v-model="spalte.name"
              append-outer-icon="mdi-delete"
              @click:append-outer="loescheSpalte(spalte.id)"
            />
          </v-col>
        </v-row>
        <b-row>
          <b-column>
            <b-btn @click="fuegeSpalteHinzu()">Spalte hinzufügen</b-btn>
          </b-column>
        </b-row>
      </div>
    </template>
  </Popup>
</template>

<script>
import Popup from '@/components/base_components/Popup';

export default {
  name: 'TemplateSpaltennamenPopup',
  components: { Popup },
  props: {
    spaltenNamen: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      spalten: [
        {
          id: 0,
          name: 'neue Spalte',
        },
      ],
    };
  },
  computed: {},
  methods: {
    closePopup() {
      this.$emit('close');
    },
    acceptAndClose() {
      let spaltennamen = [];
      this.spalten.forEach((element) => {
        spaltennamen.push(element.name);
      });
      this.$emit('save', spaltennamen);
      this.closePopup();
    },
    fuegeSpalteHinzu() {
      const neueSpalte = {
        id: this.spalten.length,
        name: 'neue Spalte',
      };
      this.spalten.push(neueSpalte);
    },
    loescheSpalte(id) {
      let temp = this.spalten.filter((element) => element.id != id);
      this.spalten = temp;
    },
  },
  created() {
    if (this.spaltenNamen && this.spaltenNamen.length > 0) {
      this.spalten = [];
      this.spaltenNamen.forEach((element, index) => {
        const spalte = {
          id: index,
          name: element,
        };
        this.spalten.push(spalte);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
</style>
